export const blueSky = '#8FECFF';
export const greenDark = '#033838';
export const white = '#FFFFFF';
export const greenBlueAnalytic = '#4DB7BD';
export const greyMid = '#F2F5F5';
export const greenLight = '#00DDA9';
export const greenLightAnalytic = '#3DFFDC';
export const blueDeepSeaAnalytic = '#268AFF';
